<div class="top">
  <div>
    <button mat-icon-button
            aria-label="Current task list" title="Current task list"
            routerLink="/current">
      <mat-icon>check</mat-icon>
    </button>
    <span *ngIf="prevSprint">
      <a routerLink="/sprint/{{prevSprint.id}}">
        &lt;&lt; {{prevSprint.name}}
      </a>
    </span>
    <span *ngIf="prevSprint && nextSprint">/</span>
    <span *ngIf="nextSprint">
      <a routerLink="/sprint/{{nextSprint.id}}">
        {{nextSprint.name}} &gt;&gt;
      </a>
    </span>
  </div>

  <div class="sprint-details" [hidden]="!dataLoaded">
    <h2>{{sprint.name}}</h2>

    <ul class="taskList">
      <li *ngFor="let task of tasks; let i = index">
        <span [ngSwitch]="task.taskState">
          <span *ngSwitchCase="3">✅ </span>
          <span *ngSwitchCase="5">❌</span>
        </span>
        <a routerLink="/task/{{task.id}}">
          {{task.id}} - {{ task.title }}
        </a>
      </li>
    </ul>
  </div>

  <div [hidden]="dataLoaded">
    <mat-spinner></mat-spinner>
  </div>
</div>
